import React from "react";
import {
  FaUniversity, FaChevronCircleDown, FaEdit, FaUser, FaPaypal,
  FaUserGraduate
} from "react-icons/fa";
import { FcCollaboration } from "react-icons/fc";
import { PiStudentBold } from "react-icons/pi";
import "./list.items.scss";
import { useNavigate } from "react-router-dom";

const ListItems = () => {
  const navigate = useNavigate();

  return (
    <div className="goodui-container">
      <div className="goodui-grid">
        <div className="goodui-column">
          <h3 className="goodui-title">🌍 Partners - Makestudy</h3>
          <div className="goodui-cards">
            <ItemCard icon={<FcCollaboration />} title="Agents"  onClick={() => navigate("/admin/agentdisplay")} />
            <ItemCard icon={<PiStudentBold />} title="Students"  />
            <ItemCard icon={<FaUniversity />} title="Program Categories"  onClick={() => navigate("/admin/programtypes")} />
            <ItemCard icon={<FaChevronCircleDown />} title="View Courses"  onClick={() => navigate("/admin/displayprograms")} />
            <ItemCard icon={<FaUser />} title="Agent Registration Users" onClick={() => navigate("/admin/agent-Registration")} />
          </div>
        </div>
        <div className="goodui-column">
          <h3 className="goodui-title">💻 Makestudy Online</h3>
          <div className="goodui-cards">
            <ItemCard icon={<FaEdit />} title="Online Courses"  onClick={() => navigate("/admin/online")} />
            <ItemCard icon={<FaUser />} title="Online Users"  onClick={() => navigate("/admin/onlineuser")} />
            <ItemCard icon={<FaPaypal />} title="Online Payments" onClick={() => navigate("/admin/payments")} />
            <ItemCard icon={<FaUserGraduate />} title="OfferLetter Users" onClick={() => navigate("/admin/Offer-Letter")} />
          </div>
        </div>
      </div>
    </div>
  );
};

const ItemCard = ({ icon, title, count, onClick }) => (
  <div className="goodui-card" onClick={onClick}>
    <div className="icon-box">{icon}</div>
    <div className="card-content">
      <h4>{title}</h4>
      {count && <span className="count">{count}</span>}
    </div>
  </div>
);

export default ListItems;
